import { ProductRequestProduct } from '@api/types';
import { Image, SmartLink } from '@components';
import { Box } from '@mui/material';
import { formatPrice } from '@utils/price.utils';

type ProductRequestProductBoxProps = {
  product?: ProductRequestProduct;
};

export const ProductRequestProductBox: React.FC<ProductRequestProductBoxProps> = ({
  product,
}: ProductRequestProductBoxProps) => {
  return (
    <Box
      sx={{
        '& img': {
          height: '100px',
          width: '100px',
        },
      }}
      gap={2}
      p={4}
      bgcolor='white'
      mb={4}
      display='flex'
    >
      <Image
        image={product?.imageUrl}
        className='product-image'
        resizerParams={{ width: 100, format: 'webp' }}
        width='100'
        height='100'
      />
      <Box display='flex' flexDirection='column' justifyContent='space-between'>
        <div>
          <SmartLink href={product?.url}>
            <div className='product-name'>{product?.displayName}</div>
          </SmartLink>
          <div className='product-id'>{product?.productNumber}</div>
        </div>

        <Box className='product-price-cell' sx={{ fontWeight: 'bold' }}>
          <div className='product-price'>{formatPrice(product?.grossPrice)}</div>
        </Box>
      </Box>
    </Box>
  );
};
